import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, formatDate } from "@/lib/api";

export default function Enquiries() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/enquiries").then(({ data }) => setItems(data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const mark = async (id, status) => {
    await api.patch(`/admin/enquiries/${id}`, { status });
    load();
  };

  return (
    <div data-testid="admin-enquiries-panel">
      <h2 className="text-2xl sm:text-3xl text-[#1a261f] mb-6">Enquiries</h2>
      <div className="space-y-3">
        {items.length === 0 && <p className="border border-[#e2dcd4] bg-white p-6 text-sm text-[#5a665e]">No enquiries yet.</p>}
        {items.map((e) => (
          <div key={e.id} className="border border-[#e2dcd4] bg-white p-5" data-testid={`enquiry-${e.id}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <p className="text-[#1a261f]">{e.name} <a href={`mailto:${e.email}`} className="text-sm text-[#3d644e] underline ml-1">{e.email}</a></p>
              <div className="flex items-center gap-3">
                <span className="font-mono-k text-[11px] text-[#5a665e]">{e.subject} · {formatDate(e.created_at)}</span>
                <button onClick={() => mark(e.id, e.status === "new" ? "read" : "new")} data-testid={`enquiry-toggle-${e.id}`}
                  className={`font-mono-k text-[10px] uppercase tracking-widest px-2 py-1 ${e.status === "new" ? "bg-[#f7efe1] text-[#6b4a14]" : "bg-[#eef3ee] text-[#1f402b]"}`}>
                  {e.status}
                </button>
              </div>
            </div>
            <p className="mt-3 text-sm text-[#3c4a41] whitespace-pre-line">{e.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
